export const RESTRICT_MODIFY_EVENT_BEFORE_SECONDS = 7200; // 2 hours
export const RESTRICT_MODIFY_EVENT_BEFORE_HOURS = RESTRICT_MODIFY_EVENT_BEFORE_SECONDS / 60 / 60;
export const ALLOW_REDEEM_EVENT_BEFORE_SECONDS = 7200; // 2 hours
